// extracted by mini-css-extract-plugin
export default {"container":"DisplayExploreRestaurent_container__1+ROo","text":"DisplayExploreRestaurent_text__04GBu","buttonContainer":"DisplayExploreRestaurent_buttonContainer__Q++AI"};